/* eslint-disable object-curly-newline, object-property-newline */

export const STATS_LEVELS = ['Easy', 'Medium', 'Hard', 'Extreme'];
export const PLAYER_STATS_LEVELS = ['Overall', 'Easy', 'Medium', 'Hard'];

// These flat lists control row labels, values, and display order only.
// The game engine calculates and saves the underlying statistics.
export const YOUR_STATS = [
	{ label: 'Games', path: 'played_match.count' },
	{ label: 'Wins', path: 'win.sum' },
	{ label: 'Win rate', path: 'win.avg', format: 'percent' },
	{ label: 'Average score', path: 'points_match.avg' },
	{ label: 'Best score', path: 'points_match.min' },
	{ label: 'Best streak', path: 'win.streakMax' },
	{ label: 'Moon shots', path: 'moon_shots.sum' },
	{ label: 'Zero point matches', path: 'zero_points_match.sum' },
];

export const DETAIL_STATS = [
	{ label: 'Level', path: 'level' },
	{ label: 'Player', path: 'player' },
	{ label: 'Avatar', path: 'avatar', format: 'avatar' },
	{ label: 'Skill', path: 'skill' },
	{ label: 'Games Played', path: 'played_match.count' },
	{ label: 'Wins', path: 'win.sum' },
	{ label: 'Losses', path: 'loss.sum' },
	{ label: 'Win Rate', path: 'win.avg', format: 'percent' },
	{ label: 'Zero Point Games', path: 'zero_points_match.sum' },
	{ label: 'Moon Shots', path: 'moon_shots.sum' },
	{ label: 'Average Points per Game', path: 'points_match.avg' },
	{ label: 'Best Game Score', path: 'points_match.min' },
	{ label: 'Games with Points under 5', path: 'points_match_under_5.sum' },
	{ label: 'Games with Points under 10', path: 'points_match_under_10.sum' },
	{ label: 'Games with Points under 20', path: 'points_match_under_20.sum' },
	{ label: 'First Place Count', path: 'first_place.sum' },
	{ label: 'Second Place Count', path: 'second_place.sum' },
	{ label: 'Third Place Count', path: 'third_place.sum' },
	{ label: 'Fourth Place Count', path: 'fourth_place.sum' },
	{ label: 'First Place Rate', path: 'first_place.avg', format: 'percent' },
	{ label: 'Second Place Rate', path: 'second_place.avg', format: 'percent' },
	{ label: 'Third Place Rate', path: 'third_place.avg', format: 'percent' },
	{ label: 'Fourth Place Rate', path: 'fourth_place.avg', format: 'percent' },
	{ label: 'Rounds Played', path: 'played_round.count' },
	{ label: 'Zero Point Rounds', path: 'zero_points_round.sum' },
	{ label: 'Average Points per Round', path: 'points_round.avg' },
	{ label: 'Average Heart Points per Round', path: 'heart_points_round.avg' },
	{ label: 'Average Q of S Points per Round', path: 'queen_spades_points_round.avg' },
	{ label: 'Average Moon Points per Round', path: 'moon_points_round.avg' },
	{ label: 'Win Streak', path: 'win.streak' },
	{ label: 'Best Win Streak', path: 'win.streakMax' },
	{ label: 'Loss Streak', path: 'loss.streak' },
	{ label: 'Worst Loss Streak', path: 'loss.streakMax' },
];
